"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: t, size: l = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = n(), r = t !== null && t !== void 0 ? t : i ? o.colors.inverse : o.colors.neutralHigh, { skinName: c } = h();
    return c.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: r,
            d: "M6.64 22a.714.714 0 0 1-.508-1.217l5.59-5.626.436.172a6.17 6.17 0 0 0 6.61-1.38 6.17 6.17 0 0 0 1.697-5.511l-3.462 3.461a2.09 2.09 0 0 1-2.956 0l-1.95-1.949a2.1 2.1 0 0 1 0-2.957l3.462-3.457a6.16 6.16 0 0 0-5.51 1.696 6.17 6.17 0 0 0-1.38 6.611l.172.437-5.626 5.586a.714.714 0 0 1-1.004-1.012l4.973-4.935a7.6 7.6 0 0 1 1.86-7.695 7.6 7.6 0 0 1 8.144-1.7l1.02.395-5.098 5.087a.667.667 0 0 0 0 .936l1.949 1.949c.26.256.68.26.936 0l5.086-5.094.396 1.016a7.6 7.6 0 0 1-1.7 8.144 7.61 7.61 0 0 1-7.695 1.86l-4.934 4.975A.71.71 0 0 1 6.64 22"
        })
    })) : c.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: r,
            d: "M6.64 22a.714.714 0 0 1-.508-1.217l5.59-5.626.436.172a6.17 6.17 0 0 0 6.61-1.38 6.17 6.17 0 0 0 1.697-5.511l-3.462 3.461a2.09 2.09 0 0 1-2.956 0l-1.95-1.949a2.1 2.1 0 0 1 0-2.957l3.462-3.457a6.16 6.16 0 0 0-5.51 1.696 6.17 6.17 0 0 0-1.38 6.611l.172.437-5.626 5.586a.714.714 0 0 1-1.004-1.012l4.973-4.935a7.6 7.6 0 0 1 1.86-7.695 7.6 7.6 0 0 1 8.144-1.7l1.02.395-5.098 5.087a.667.667 0 0 0 0 .936l1.949 1.949c.26.256.68.26.936 0l5.086-5.094.396 1.016a7.6 7.6 0 0 1-1.7 8.144 7.61 7.61 0 0 1-7.695 1.86l-4.934 4.975A.71.71 0 0 1 6.64 22"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: r,
            d: "M17.28 2.247a6.6 6.6 0 0 1 1.13-.112h.005c.552.003 1.011.297 1.207.768.197.47.073 1.008-.316 1.397l-.572.569.05.347.348.05.569-.568c.263-.263.596-.409.938-.409.426 0 .818.221 1.037.586.129.218.196.464.193.717q-.008.557-.107 1.103c-.16.885-.479 1.572-.946 2.04-.462.462-1.137.778-2.009.94q-.508.096-1.025.113l-7.991 7.991a6.6 6.6 0 0 1-.104.995c-.163.885-.482 1.571-.95 2.039-.462.465-1.137.781-2.008.944q-.56.104-1.129.112h-.006c-.551-.003-1.014-.297-1.21-.77s-.072-1.009.317-1.395l.571-.572-.05-.347-.347-.05-.572.57a1.33 1.33 0 0 1-.938.41c-.426 0-.818-.221-1.037-.586a1.4 1.4 0 0 1-.193-.717q.008-.557.107-1.103c.162-.886.481-1.572.95-2.04.461-.462 1.136-.778 2.008-.94q.507-.097 1.025-.113l7.994-7.991q.014-.502.104-.995c.162-.885.482-1.571.95-2.039.462-.465 1.137-.781 2.008-.944m1.233 1.263c.14-.14.09-.255-.106-.255-.053 0-1.625.006-2.348.726-.73.734-.725 2.347-.725 2.347a1 1 0 0 1-.252.614l-8.14 8.14a1 1 0 0 1-.61.252h-.004c-.053 0-1.624.005-2.344.725-.731.734-.726 2.348-.726 2.348 0 .12.045.185.11.185q.064 0 .145-.082l.712-.711a.83.83 0 0 1 .535-.207q.038 0 .075.005l1.023.146c.196.028.378.21.406.406l.146 1.022a.81.81 0 0 1-.205.611l-.711.712c-.138.14-.09.254.106.254h.003c.053 0 1.625-.005 2.344-.725.731-.734.726-2.347.726-2.347 0-.2.112-.474.252-.614l8.14-8.14a1 1 0 0 1 .61-.252h.003c.054 0 1.625-.006 2.345-.725.731-.734.726-2.348.726-2.348 0-.12-.045-.185-.11-.185q-.064 0-.145.082l-.712.711a.83.83 0 0 1-.535.207 1 1 0 0 1-.075-.005l-1.023-.146a.51.51 0 0 1-.406-.406l-.146-1.023a.81.81 0 0 1 .205-.61z"
        })
    }));
}, d = s;
export { d as default };
